import angular from 'angular';

export class MovimentacoesDetalheDrawerSummaryComponent implements angular.IComponentOptions {
    static selector = 'movimentacoesDetalheDrawerSummary';
    static template = require('!!html-loader!./movimentacoes-detalhe-drawer-summary.component.html');
    static bindings = {
        summary: '<'
    };
}
